import { render, staticRenderFns } from "./MakeFlowableForm.vue?vue&type=template&id=619ccf60"
import script from "./MakeFlowableForm.vue?vue&type=script&lang=js"
export * from "./MakeFlowableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619ccf60')) {
      api.createRecord('619ccf60', component.options)
    } else {
      api.reload('619ccf60', component.options)
    }
    module.hot.accept("./MakeFlowableForm.vue?vue&type=template&id=619ccf60", function () {
      api.rerender('619ccf60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/form/MakeFlowableForm.vue"
export default component.exports